import { createStore }  from 'vuex'
import wAuth from '@/plugins/w/authStore/wAuth.store'
import shoppingList from '@/plugins/appshoppinglist/store/store'

const store = createStore({
	modules: {
		wAuth,
		shoppingList
	}
})

export default store
